import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Typography, Alert, Layout } from 'antd';
import logo from '../images/nepal-government-logo.png'; // Import logo

const { Title } = Typography;
const { Content } = Layout;

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const { login } = useAuth(); // AuthContext's login function
    const navigate = useNavigate();

    // Function to handle login with JWT
    const handleLogin = async (values) => {
        try {
            // Send login request to the backend
            const result = await axios.post('https://ward3-chandrapur-api.palikaapp.com/api/user/login', {
                username: values.username,
                password: values.password,
            });

            // Assuming result.data.token contains the JWT token
            login(result.data.token); // Call AuthContext's login method
            setError(null); // Clear any previous errors
            navigate('/houseList'); // Navigate to a protected route
        } catch (err) {
            // Set error message on login failure
            setError('Invalid username or password');
        }
    };

    return (
        <div>
            {/* Minimal Header */}
            <header style={{ 
    display: 'flex', 
    alignItems: 'center', 
    padding: '10px 20px', // Reduced padding for smaller header height
    backgroundColor: '#f8f9fa', 
    justifyContent: 'flex-start',
    borderBottom: '2px solid red', // Added red border
    boxShadow: '0 4px 2px -2px rgba(255, 0, 0, 0.3)', // Added subtle red shadow
    position:'fixed',
    zIndex:1000,
    width:'100%'
}}>
    <img src={logo} alt="Nepal Government Logo" style={{ height: '60px', marginRight: '20px' }} /> {/* Reduced logo height */}
    <div>
        <h1 style={{ 
            margin: 0, 
            fontSize: '1.5rem', 
            color: 'red', // Red text for the header title
        }}>
            चन्द्रपुर नगरपालिका वडा ३
        </h1>
        <p style={{
            margin: 0, 
            fontSize: '0.9rem', 
            color: 'red' // Gray color for the smaller text
        }}>
            रौतहट, मधेश प्रदेश, नेपाल
        </p>
    </div>
</header>


            <Layout style={{ height: '100vh', backgroundColor: '#f0f4f8' }}>
                <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ width: 400, backgroundColor: '#fff', padding: 40, borderRadius: 8, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
                        <Title level={2} style={{ textAlign: 'center' }}>Login</Title>
                        <Form
                            layout="vertical"
                            onFinish={handleLogin} // Call handleLogin on form submit
                            initialValues={{ username, password }}
                        >
                            <Form.Item
                                label="Username"
                                name="username"
                                rules={[{ required: true, message: 'Please input your username!' }]}
                            >
                                <Input
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Password"
                                name="password"
                                rules={[{ required: true, message: 'Please input your password!' }]}
                            >
                                <Input.Password
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ width: '100%' }}
                                >
                                    Login
                                </Button>
                            </Form.Item>
                        </Form>
                        {error && <Alert message={error} type="error" showIcon style={{ marginTop: 10 }} />}
                    </div>
                </Content>
            </Layout>
        </div>
    );
};

export default Login;
